import { useMarketIntelligencePermissions } from '@/hooks/permissions/marketIntelligence/useMarketIntelligencePermissions'
import { MarketIntelligencePages } from '@/routes/MarketIntelligencePages'
import { PATHS } from '@/routes/PATHS'
import { CoreLevelFeatureNames } from '@/services/types/permissions/permissionFeatures/mockCorePermissionFeature'
import { PremiumFeatures } from '@/services/types/premiumFeatures/premiumFeatures'
import { useCorePermissions } from '@/stores/permissions/permissions'
import { usePremiumFeaturesPermissions } from '@/stores/permissions/premiumFeatures'
import { AlertOutlined, FireOutlined, PieChartOutlined, SearchOutlined } from '@ant-design/icons'
import { Lightbulb } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const ICON_SIZE = 14

export function useAnalyticsSidebarItems() {
  const { t } = useTranslation()
  const { shouldShowMarketIntelligencePages } = useMarketIntelligencePermissions()

  const reportsPermission = useCorePermissions(CoreLevelFeatureNames.emailedReports)
  const listingsManagementPermission = useCorePermissions(CoreLevelFeatureNames.listingsManagement)

  const premiumFeaturesPermissions = usePremiumFeaturesPermissions()
  const hasListingsFeature = premiumFeaturesPermissions.includes(PremiumFeatures.Listings)
  const hasReviewMonitoringFeature = premiumFeaturesPermissions.includes(
    PremiumFeatures.ReviewMonitoring,
  )

  const hasReportsPermission = !!reportsPermission?.edit
  const shouldHideListingsPageItem = !!listingsManagementPermission?.hide
  const hideListingsPageItem = shouldHideListingsPageItem || !hasListingsFeature
  const hasReportsFeature = hasListingsFeature || hasReviewMonitoringFeature

  const allItems = [
    {
      key: PATHS.analyticsPage,
      label: t('sidebarItems.customerInteractions'),
      path: PATHS.analyticsPage,
      icon: <PieChartOutlined />,
    },
    {
      key: PATHS.searchAppearancesPage,
      label: t('sidebarItems.searchAppearances'),
      path: PATHS.searchAppearancesPage,
      icon: <SearchOutlined />,
    },
    {
      key: PATHS.reviewAnalysis,
      label: t('sidebarItems.reviewsInsights'),
      path: PATHS.reviewAnalysis,
      icon: <FireOutlined />,
    },
    {
      key: PATHS[MarketIntelligencePages.locationsTable],
      label: t('sidebarItems.marketIntelligence'),
      path: PATHS[MarketIntelligencePages.locationsTable],
      icon: <Lightbulb size={ICON_SIZE} />,
    },
    {
      key: PATHS.emailReportsPage,
      label: t('sidebarItems.reports'),
      path: PATHS.emailReportsPage,
      icon: <AlertOutlined />,
    },
  ]

  return allItems
    .filter((item) =>
      hasReportsPermission && hasReportsFeature ? true : item.key !== PATHS.emailReportsPage,
    )
    .filter((item) => (hasReviewMonitoringFeature ? true : item.key !== PATHS.reviewAnalysis))
    .filter((item) =>
      shouldShowMarketIntelligencePages
        ? true
        : item.key !== PATHS[MarketIntelligencePages.locationsTable],
    )
    .filter((item) => (hideListingsPageItem ? item.key !== PATHS.analyticsPage : true))
    .filter((item) => (hideListingsPageItem ? item.key !== PATHS.searchAppearancesPage : true))
}
